import React from "react";
import { ShieldCheck, Lock, Cpu, BadgeCheck } from "lucide-react";

const CATEGORIES = [
  "UI/UX Design", "Web Development", "Copywriting", "Branding", "SEO",
  "Video Editing", "Data Analysis", "Mobile Apps", "Illustration",
  "Marketing", "Voiceover", "Consulting",
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="py-14">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
          Gigs your agent can sell — out of the box
        </p>

        <div className="mt-6 relative overflow-hidden" style={{ maskImage: "linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)", WebkitMaskImage: "linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)" }}>
          <div className="flex gap-3 animate-marquee whitespace-nowrap">
            {[...CATEGORIES, ...CATEGORIES].map((l, i) => (
              <span
                key={i}
                className="inline-flex items-center px-4 py-2 rounded-full border border-slate-200 bg-white text-slate-700 text-sm font-medium font-display"
              >
                {l}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: ShieldCheck, label: "Escrow protected" },
            { icon: Lock, label: "End-to-end encryption" },
            { icon: Cpu, label: "GPT-5.2 powered" },
            { icon: BadgeCheck, label: "Payouts in ₹ via UPI" },
          ].map((b) => (
            <div key={b.label} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3">
              <b.icon size={18} className="text-blue-600" />
              <span className="text-sm font-medium text-slate-700">{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
